import React from 'react';

import { designSystem } from '@/styles/theme';

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

const NavSubwayIcon: React.FC<IconProps> = ({ width = 24, height = 24, color = designSystem.colors.primary }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="3" width="16" height="14" rx="3" stroke={color} strokeWidth="2" fill="none"/>
    <circle cx="8" cy="13" r="1.5" fill={color}/>
    <circle cx="16" cy="13" r="1.5" fill={color}/>
    <line x1="4" y1="9" x2="20" y2="9" stroke={color} strokeWidth="2"/>
    <line x1="8" y1="17" x2="6" y2="21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
    <line x1="16" y1="17" x2="18" y2="21" stroke={color} strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export default NavSubwayIcon;
